// 操作引导 — the two routes (copy approved in the prototype, scratchpad tour-proto/*.dc.html).
//
// Each step:
//   title, body (string | string[] for a numbered list), rule (grey box, optional)
//   cat / short          catalogue names (「这是什么？」 / the /guide page)
//   screen               where the step happens:
//     path               page the tour navigates to (null = stay)
//     ws                 the demo 客户工作台 on top: { tab, composer, report, stepFocus, rect }
//     sv                 服务监督 tab: 'coaches' | 'reports'
//   target               data-tour value(s) to spotlight (array → union of the rects)
//   markers              numbered badges on sub-targets [{ t, n }]
//   next                 label of the forward button (default 下一步 / 完成 on the last step)
//   clickTarget          data-tour value the user may click instead of the forward button (advances)
// The demo data the screens show comes from ./tourFixtures.js.

export const TOUR_VERSION = 1;

export const ROUTE_META = {
  coach: {
    key: 'coach',
    name: '教练路线',
    blurb: '今天联系谁 → 写联系记录 → 记备忘录 → 打勾服务进度 → 写月报',
  },
  supervisor: {
    key: 'supervisor',
    name: '主管路线',
    blurb: '看红黄灯 → 看老师 KPI → 审核记录 → 开整改单 → 审月报',
    shortBlurb: '看红黄灯 → 老师 KPI → 审核 → 整改单 → 月报',
    audience: '主管、经理适用',
  },
};

export const ROUTES = {
  coach: [
    {
      key: 'c1',
      cat: '认识客户工作台',
      short: '认识客户工作台',
      title: '这是一位会员的客户工作台',
      body: [
        'TA 签约第几天、现在走到服务流程的哪一步',
        '状态灯：绿正常、黄需要关注、红必须处理，鼠标移上去看原因',
        '最常用的按钮：每次联系完会员都点这里记下来',
        '五个页签从左到右：今天做什么 → 进度 → 记录 → 资料',
      ],
      screen: { ws: { tab: 'next' } },
      target: ['ws-top', 'ws-tabs'],
      markers: [{ t: 'ws-stage', n: 1 }, { t: 'ws-light', n: 2 }, { t: 'ws-log', n: 3, hollow: true }, { t: 'ws-tab-profile', n: 4 }],
    },
    {
      key: 'c2',
      cat: '每天先看「今日跟进」',
      short: '每天先看今日跟进',
      title: '每天先看「今日跟进」',
      body: '这里列出今天必须处理的会员，已逾期的排在最前面。点一个会员，就会打开 TA 的客户工作台。',
      rule: '规则：前三个月没有合适推荐时，每 48 小时至少有效联系一次。',
      screen: { path: '/profiles' },
      target: 'followup-bar',
      next: '点陈先生试试 →',
      clickTarget: 'followup-demo',
    },
    {
      key: 'c3',
      cat: '看「下一步」：今天为 TA 做什么',
      short: '看「下一步」',
      title: '「下一步」：一张卡一件事',
      body: '红点最急，黄点其次。每张卡写着为什么要做、什么时候到期，只有一个按钮，点了就去做。',
      rule: '全部做完会显示「都完成了 ✓」和下次联系时间。',
      screen: { ws: { tab: 'next' } },
      target: 'ws-next-first',
      next: '点「写联系记录」→',
      clickTarget: 'ws-next-first-btn',
    },
    {
      key: 'c4',
      cat: '写联系记录并上传截图',
      short: '写联系记录并上传截图',
      title: '打完电话，上传通话截图',
      body: '每种方式都要上传截图或照片：电话 / 语音 / 视频传通话截图（能看到通话时间和时长），文字传聊天截图，当面传见面照片。没有照片不能保存；方式选「电话」时还要填下次联系时间。',
      rule: '会员没接？选「已联系，未回复」如实记录，不算双向沟通。',
      screen: { ws: { tab: 'next', composer: 'contact' } },
      target: 'ws-contact-shots',
    },
    {
      key: 'c5',
      cat: '答应会员的事记进备忘录',
      short: '答应会员的事记进备忘录',
      title: '答应会员的事，马上记进备忘录',
      body: '写下要做什么，选一个时间。到时间小铃铛会提醒你；过期 24 小时没做完，主管也会收到提醒。',
      rule: '规则：答应会员的事必须当天进 CRM，没有记录的承诺算执行不合格。',
      screen: { ws: { tab: 'next', memo: true } },
      target: 'ws-memo',
      next: '点「记下」→',
      clickTarget: 'ws-memo-add',
    },
    {
      key: 'c6',
      cat: '在「服务进度」里完成一步',
      short: '在服务进度里完成一步',
      title: '做完一步，在服务进度里打勾',
      body: '每一步都写着完成标准和时限。有些步骤系统会自动打勾（比如交叉电话），其余的做完后点「标记完成」。',
      rule: '推荐不合适就选「复盘」，系统自动开始第 2 轮；一对一满 3 个月后结单。',
      screen: { ws: { tab: 'steps', stepFocus: 'first_recs' } },
      target: 'ws-step-first_recs',
    },
    {
      key: 'c7',
      cat: '每月写服务报告，提交主管',
      short: '每月写服务报告',
      title: '每满 30 天，写一份服务报告',
      body: '数字由系统自动统计。点「AI 起草全文」先出草稿，你再改；写好后提交主管审核，通过后会员在「我的」里看到。',
      rule: '不要写其他会员的名字和内部评价；没有记录的事不要写进报告。',
      screen: { ws: { tab: 'profile', report: true } },
      target: 'report-editor',
      next: '完成',
    },
  ],
  supervisor: [
    {
      key: 's1',
      cat: '看红黄灯会员',
      short: '看红黄灯会员',
      title: '每周一次，先看红灯和黄灯',
      body: '红灯 = 必须你介入（48 小时没联系、14 天没推荐、严重投诉）。黄灯 = 需要关注（7 天没进展）。',
      rule: '规则：红灯会员由主管直接介入，明确整改负责人和截止时间。',
      screen: { path: '/service-supervision', sv: 'coaches' },
      target: 'sv-stats',
    },
    {
      key: 's2',
      cat: '看每位老师的 KPI',
      short: '看每位老师的 KPI',
      title: '看每位老师的 KPI，颜色就是结论',
      body: '绿色 90% 以上达标，黄色 60–89% 一般，红色低于 60% 要处理。分数低、红灯多的老师排在最前面。点老师名字看 TA 的所有会员。',
      rule: '考核不能只看推荐数量，要看精准度、服务效率、CRM 记录和会员体验。',
      screen: { path: '/service-supervision', sv: 'coaches' },
      target: 'sv-coaches',
      next: '点 Kevin 试试 →',
      clickTarget: 'sv-coach-kevin',
    },
    {
      key: 's3',
      cat: '看一位会员的检查清单',
      short: '看一位会员的检查清单',
      title: '先看检查清单，找出哪里没做到',
      body: '红色 ✗ 就是没达标的地方。这里 Amy 有 2 次超过 48 小时没联系、1 件答应会员的事没按时做。',
      rule: '下一步：通过或退回待审核的联系记录；不达标的，开一张整改单，写清楚做什么、谁做、哪天前。',
      screen: { path: '/service-supervision', sv: 'coaches', ws: { tab: 'review' } },
      target: 'ws-review-kpi',
    },
    {
      key: 's4',
      cat: '通过或退回联系记录',
      short: '通过或退回联系记录',
      title: '逐条通过或退回联系记录',
      body: '看三样：有没有截图、内容是不是真的在推进（筛选、核实、下一步）、结果有没有如实选。合格点「通过」；不合格点「退回」并写原因，老师会收到提醒。',
      rule: '简单问候、点赞朋友圈、转发广告不算有效服务。',
      screen: { path: '/service-supervision', sv: 'coaches', ws: { tab: 'review' } },
      target: 'ws-review-pending',
    },
    {
      key: 's5',
      cat: '开整改单',
      short: '开整改单',
      title: '不达标，就开整改单',
      body: '写清楚做什么、谁来做、哪天前。老师会在「下一步」里看到并收到提醒；做完后标记完成，你再确认「核实通过」或「退回重做」。',
      rule: '不要只说“多关心一下会员”，要写具体的事、负责人和截止日期。',
      screen: { path: '/service-supervision', sv: 'coaches', ws: { tab: 'review', rect: true } },
      target: 'ws-review-rect',
    },
    {
      key: 's6',
      cat: '审核月度报告',
      short: '审核月度报告',
      title: '审核月报：勾完 3 项才能发布',
      body: '发布后会员会在「我的 › 服务报告」里看到，并收到通知。有问题就退回，写明要改什么。',
      rule: '你自己写的报告，要由另一位主管审核。',
      screen: { path: '/service-supervision', sv: 'reports' },
      target: 'sv-report-review',
      next: '完成',
    },
  ],
};

export const routeTotal = (route) => (ROUTES[route] || []).length;

// The one-line explanations shown under each workspace tab's 「这是什么？」.
export const TAB_EXPLAIN = {
  next: '「下一步」列出今天要为这位会员做的事。每张卡写明为什么要做，点卡上的按钮就去做。',
  steps: '「服务进度」是 SOP 5.0 的每一步：开始阶段只做一次，推荐一轮一轮来。点开一步看完成标准，做到了再标记完成。',
  records: '「全部记录」是这位会员的所有联系、推荐、约见、备注和投诉，按时间从新到旧，点一条看详情。',
  profile: '「资料·报告」放会员资料、匹配速记卡、测评、月度服务报告和付款记录。',
  review: '「审核」给主管用：先看 KPI 检查清单，再通过或退回待审核的记录，不达标就开整改单。',
};

// 主管 roles — same list as the backend's SUPERVISOR_ROLES.
export const SUPERVISOR_ROLES = ['leader_coach', 'supervisor_coach', 'supervisor', 'manager', 'admin', 'super_admin'];
